import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';

class SortBy extends Component {
  constructor(props) {
    super(props);
    if (props.sortState) {
      this.state = props.sortState;
    } else {
      this.state = {
        sortBy: false,
        sortByText: props.reviewsSort ? "Rating - Highest to Lowest" : "Newest to Oldest"
      };
    }
    this.filterDropDown = this.filterDropDown.bind(this);
  }
  filterDropDown(e) {
    this.props.sortCallback(e, this.state);
    this.setState({ sortByText: e });
  }
  render() {
    return (
      <div className="sorting-list" onClick={this.props.mapVisible}>
        <DropdownButton bsSize="small" id="dropdown-size-small" noCaret onSelect={this.filterDropDown.bind(this)} onToggle={(e) => { this.setState({ sortBy: e }) }} open={this.state.sortBy} title={
          <span className="holder">
            <i className={this.state.sortByText ? "mdi mdi-swap-vertical pull-left active" : "mdi mdi-swap-vertical pull-left"} />
            <label>Sort by</label>
            <i className={this.state.sortBy ? "mdi mdi-chevron-up pull-right" : "mdi mdi-chevron-down pull-right"} />
          </span>
        } >
          {this.props.reviewsSort ? <MenuItem eventKey="Rating - Highest to Lowest"
            className={this.state.sortByText == "Rating - Highest to Lowest" ? 'active' : ""}>Rating - Highest to Lowest
                                                {this.state.sortByText == "Rating - Highest to Lowest" && <i className="mdi mdi-check" />}</MenuItem> : ''}
          {this.props.reviewsSort ? <MenuItem eventKey="Rating - Lowest to Highest"
            className={this.state.sortByText == "Rating - Lowest to Highest" ? 'active' : ""}>Rating - Lowest to Highest
                                                {this.state.sortByText == "Rating - Lowest to Highest" && <i className="mdi mdi-check" />}</MenuItem> : ''}
          {!this.props.reviewsSort ? <MenuItem eventKey="Nearest First"
            className={this.state.sortByText == "Nearest First" ? 'active' : ""}>Nearest First
                                                {this.state.sortByText == "Nearest First" && <i className="mdi mdi-check" />}</MenuItem> : ''}
          {!this.props.reviewsSort ? <MenuItem eventKey="Farthest First" className={this.state.sortByText == "Farthest First" ? 'active' : ""}>Farthest First
                                                {this.state.sortByText == "Farthest First" && <i className="mdi mdi-check" />}
          </MenuItem> : ''}
          <MenuItem eventKey="Newest to Oldest" className={this.state.sortByText == "Newest to Oldest" ? 'active' : ""}>Date: Newest to Oldest
                                                {this.state.sortByText == "Newest to Oldest" && <i className="mdi mdi-check" />}
          </MenuItem>
          <MenuItem eventKey="Oldest to Newest" className={this.state.sortByText == "Oldest to Newest" ? 'active' : ""}>Date: Oldest to Newest
                                                {this.state.sortByText == "Oldest to Newest" && <i className="mdi mdi-check" />}
          </MenuItem>

        </DropdownButton>
      </div>
    );
  }
}

export default SortBy;



// WEBPACK FOOTER //
// ./src/components/Results/SortBy.jsx